<template>
  <ul id="accordionSidebar" class="navbar-nav sidebar sidebar-dark accordion">
    <!-- Sidebar - Brand -->
    <router-link
      class="sidebar-brand d-flex align-items-center justify-content-center"
      to="/"
      style="margin-top: 24px; margin-bottom: 41px"
    >
      <div class="sidebar-brand-text mx-3">
        <img alt="" src="@/assets/paxelmarket_admin.png" width="125" />
      </div>
    </router-link>

    <!-- Divider -->

    <!-- Nav Item - Dashboard -->
    <li class="nav-item">
      <router-link
        :class="{
          'active border-right-active': path[1] === 'dashboard',
        }"
        :to="{ name: 'Dashboard' }"
        class="nav-link"
        @click="hideSidebar('dashboard')"
      >
        <span class="text-start">DASHBOARD</span>
      </router-link>
    </li>

    <li class="nav-item">
      <router-link
        :class="{
          'active border-right-active': path[1] === 'reports',
        }"
        :to="{ name: 'reports' }"
        class="nav-link"
        @click="hideSidebar('reports')"
      >
        <span class="text-start">REPORTS</span>
      </router-link>
    </li>

    <li class="nav-item">
      <a
        :class="collapsed == 'users' ? 'collapsed' : ''"
        class="nav-link"
        data-toggle="collapse"
        href="#"
        @click="hideSidebar('users')"
      >
        <span>USERS</span>
      </a>
      <div :class="collapsed == 'users' ? 'show' : ''" class="collapse">
        <div class="bg-white collapse-inner text-start">
          <!-- <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'all-users',
            }"
            :to="{ name: 'All-Users' }"
          >
            <div class="sidebar-icon">
              <div class="icon-users"></div>
            </div>
            Users
          </router-link> -->
          <router-link
            :class="{
              'active border-right-active': path[2] === 'buyers',
            }"
            :to="{ name: 'Buyers' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-buyers"></div>
            </div>
            Buyers
          </router-link>
          <router-link
            :class="{
              'active border-right-active': path[2] === 'sellers',
            }"
            :to="{ name: 'Sellers' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-sellers"></div>
            </div>
            Sellers
          </router-link>
          <!-- <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'roles',
            }"
            :to="{ name: 'Roles' }"
          >
            <div class="sidebar-icon">
              <div class="icon-roles"></div>
            </div>
            Roles
          </router-link> -->
        </div>
      </div>
    </li>
    <li class="nav-item">
      <a
        :class="collapsed == 'products' ? 'collapsed' : ''"
        class="nav-link"
        data-toggle="collapse"
        href="#"
        @click="hideSidebar('products')"
      >
        <span>PRODUCTS</span>
      </a>
      <div :class="collapsed == 'products' ? 'show' : ''" class="collapse">
        <div class="bg-white collapse-inner text-start">
          <router-link
            :class="{
              'active border-right-active': path[2] === 'all-product',
            }"
            :to="{ name: 'All-Product' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-allproduct"></div>
            </div>
            All Product
          </router-link>
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'category-product',
            }"
            :to="{ name: 'Category-Product' }"
          >
            <div class="sidebar-icon">
              <div class="icon-category"></div>
            </div>
            Category Product
          </router-link>
          <router-link
            :class="{
              'active border-right-active': path[2] === 'category-promo',
            }"
            :to="{ name: 'Category-Promo' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-category"></div>
            </div>
            Category Promo
          </router-link>
        </div>
      </div>
    </li>
    <li class="nav-item">
      <a
        :class="collapsed == 'finance' ? 'collapsed' : ''"
        class="nav-link"
        data-toggle="collapse"
        href="#"
        @click="hideSidebar('finance')"
      >
        <span>FINANCE</span>
      </a>
      <div :class="collapsed == 'finance' ? 'show' : ''" class="collapse">
        <div class="bg-white collapse-inner text-start">
          <router-link
            :class="{
              'active border-right-active': path?.[2]?.startsWith('refund'),
            }"
            :to="{ name: 'Refund' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-refund"></div>
            </div>
            Refund
          </router-link>
          <router-link
            :class="{
              'active border-right-active': path[2] === 'withdraw',
            }"
            :to="{ name: 'Withdraw' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-withdraw"></div>
            </div>
            Withdraw
          </router-link>
          <router-link
            :class="{
              'active border-right-active': path[2] === 'sellers-commission',
            }"
            :to="{ name: 'Sellers-Commission' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-order-fee"></div>
            </div>
            Orders Fee
          </router-link>
        </div>
      </div>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        :class="collapsed == 'marketing' ? 'collapsed' : ''"
        href="#"
        data-toggle="collapse"
        @click="hideSidebar('marketing')"
      >
        <span>MARKETING</span>
      </a>
      <div class="collapse" :class="collapsed == 'marketing' ? 'show' : ''">
        <div class="bg-white collapse-inner text-start">
          <!-- <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'announcement',
            }"
            :to="{ name: 'Announcement' }"
          >
            <div class="sidebar-icon">
              <div class="icon-announcement"></div>
            </div>
            Announcement
          </router-link> -->
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'homepage-buyer',
            }"
            :to="{ name: 'HomepageBuyer' }"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            Homepage Buyer
          </router-link>
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'promo-list',
            }"
            :to="{ name: 'PromoList' }"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            UA Promo List
          </router-link>
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'vouchers',
            }"
            :to="{ name: 'Vouchers' }"
          >
            <div class="sidebar-icon">
              <div class="icon-voucher"></div>
            </div>
            Vouchers
          </router-link>
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'banners',
            }"
            :to="{ name: 'Banners' }"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            Banners
          </router-link>
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'content-text',
            }"
            :to="{ name: 'ContentText' }"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            Content Text
          </router-link>
        </div>
      </div>
    </li>
    <li class="nav-item">
      <a
        :class="collapsed == 'orders' ? 'collapsed' : ''"
        class="nav-link"
        data-toggle="collapse"
        href="#"
        @click="hideSidebar('orders')"
      >
        <span>ORDERS</span>
      </a>
      <div :class="collapsed == 'orders' ? 'show' : ''" class="collapse">
        <div class="bg-white collapse-inner text-start">
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'orders',
            }"
            :to="{ name: 'Orders' }"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            All Orders
          </router-link>
          <!-- <router-link
            :class="{
              'active border-right-active': path[2] === 'reports',
            }"
            :to="{ name: 'Reports' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            Reports
          </router-link> -->
        </div>
      </div>
    </li>
    <!-- <li class="nav-item">
      <a
        :class="collapsed == 'settings' ? 'collapsed' : ''"
        class="nav-link"
        data-toggle="collapse"
        href="#"
        @click="hideSidebar('settings')"
      >
        <span>GENERAL SETTINGS</span>
      </a>
      <div :class="collapsed == 'settings' ? 'show' : ''" class="collapse">
        <div class="bg-white collapse-inner text-start">
          <router-link
            :class="{
              'active border-right-active': path[2] === 'general-setting',
            }"
            :to="{ name: 'General-Setting' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            General Setting
          </router-link>
        </div>
      </div>
    </li> -->
    <li class="nav-item">
      <a
        :class="collapsed === 'sla' ? 'collapsed' : ''"
        class="nav-link"
        data-toggle="collapse"
        href="#"
        @click="hideSidebar('sla')"
      >
        <span>SLA</span>
      </a>
      <div :class="collapsed === 'sla' ? 'show' : ''" class="collapse">
        <div class="bg-white collapse-inner text-start">
          <router-link
            :class="{
              'active border-right-active': path[2] === 'public-holiday',
            }"
            :to="{ name: 'public-holiday' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            Public Holiday
          </router-link>
          <router-link
            :class="{
              'active border-right-active': path[2] === 'sla-seller',
            }"
            :to="{ name: 'sla-seller' }"
            class="collapse-item"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            SLA Seller
          </router-link>
        </div>
      </div>
    </li>
    <!-- <li class="nav-item">
      <a
        class="nav-link"
        :class="collapsed == 'paxelcorp' ? 'collapsed' : ''"
        href="#"
        data-toggle="collapse"
        @click="hideSidebar('paxelcorp')"
      >
        <span>PAXELCORP</span>
      </a>
      <div class="collapse" :class="collapsed == 'paxelcorp' ? 'show' : ''">
        <div class="bg-white collapse-inner text-start">
          <router-link
            class="collapse-item"
            :class="{
              'active border-right-active': path[2] === 'api',
            }"
            :to="{ name: 'Api' }"
          >
            <div class="sidebar-icon">
              <div class="icon-manage"></div>
            </div>
            API
          </router-link>
        </div>
      </div>
    </li> -->
  </ul>
</template>

<script>
export default {
  data() {
    return {
      collapsed: "",
    };
  },
  created() {
    this.collapsed = this.path[1];
  },
  computed: {
    path() {
      return this.$route.path.split("/");
    },
  },
  methods: {
    hideSidebar(value) {
      if (this.collapsed == value) {
        this.collapsed = "";
      } else {
        this.collapsed = value;
      }
    },
    logout() {
      this.$swal({
        title: "Are you sure want to Log Out?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then(async(result) => {
        if (result.value) {
          if (process.env.VUE_APP_ENABLE_GOOGLE_LOGIN == 'true') {
            await this.$store.dispatch("googleLogout", {})
          }
          localStorage.token = "";
          this.$router.push({ name: "Login" });
          this.$swal({
            icon: "success",
            title: "Thanks for visiting !!",
            text: "PaxelMarket CMS 2.0",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
  },
  watch: {},
};
</script>

<style>
.secondsub-sidebar {
  color: #999;
}

.sidebar-icon {
  width: 25px;
  height: 25px;
  vertical-align: sub;
  display: inline-flex;
}

.collapse-item.active .sidebar-icon .icon-users,
.collapse-item.active .sidebar-icon .icon-users {
  background-image: url("~@/assets/sidebar/sidebar-icon-users.svg");
}

.collapse-item:hover .sidebar-icon .icon-users,
.collapse-item:hover .sidebar-icon .icon-users {
  background-image: url("~@/assets/sidebar/sidebar-icon-users.svg");
}

.sidebar-icon .icon-users {
  background-image: url("~@/assets/sidebar/sidebar-icon-users-disable.svg");
  width: -webkit-fill-available;
}

.sidebar-icon .icon-buyers {
  background-image: url("~@/assets/sidebar/sidebar-icon-buyers-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-buyers,
.collapse-item.active .sidebar-icon .icon-buyers {
  background-image: url("~@/assets/sidebar/sidebar-icon-buyers.svg");
}

.collapse-item:hover .sidebar-icon .icon-buyers,
.collapse-item:hover .sidebar-icon .icon-buyers {
  background-image: url("~@/assets/sidebar/sidebar-icon-buyers.svg");
}

.sidebar-icon .icon-sellers {
  background-image: url("~@/assets/sidebar/sidebar-icon-sellers-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-sellers,
.collapse-item.active .sidebar-icon .icon-sellers {
  background-image: url("~@/assets/sidebar/sidebar-icon-sellers.svg");
}

.collapse-item:hover .sidebar-icon .icon-sellers,
.collapse-item:hover .sidebar-icon .icon-sellers {
  background-image: url("~@/assets/sidebar/sidebar-icon-sellers.svg");
}

.sidebar-icon .icon-roles {
  background-image: url("~@/assets/sidebar/sidebar-icon-roles-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-roles,
.collapse-item.active .sidebar-icon .icon-roles {
  background-image: url("~@/assets/sidebar/sidebar-icon-roles.svg");
}

.collapse-item:hover .sidebar-icon .icon-roles,
.collapse-item:hover .sidebar-icon .icon-roles {
  background-image: url("~@/assets/sidebar/sidebar-icon-roles.svg");
}

.sidebar-icon .icon-allproduct {
  background-image: url("~@/assets/sidebar/sidebar-icon-allproduct-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-allproduct,
.collapse-item.active .sidebar-icon .icon-allproduct {
  background-image: url("~@/assets/sidebar/sidebar-icon-allproduct.svg");
}

.collapse-item:hover .sidebar-icon .icon-allproduct,
.collapse-item:hover .sidebar-icon .icon-allproduct {
  background-image: url("~@/assets/sidebar/sidebar-icon-allproduct.svg");
}

.sidebar-icon .icon-category {
  background-image: url("~@/assets/sidebar/sidebar-icon-category-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-category,
.collapse-item.active .sidebar-icon .icon-category {
  background-image: url("~@/assets/sidebar/sidebar-icon-category.svg");
}

.collapse-item:hover .sidebar-icon .icon-category,
.collapse-item:hover .sidebar-icon .icon-category {
  background-image: url("~@/assets/sidebar/sidebar-icon-category.svg");
}

.sidebar-icon .icon-refund {
  background-image: url("~@/assets/sidebar/sidebar-icon-refund-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-refund,
.collapse-item.active .sidebar-icon .icon-refund {
  background-image: url("~@/assets/sidebar/sidebar-icon-refund.svg");
}

.collapse-item:hover .sidebar-icon .icon-refund,
.collapse-item:hover .sidebar-icon .icon-refund {
  background-image: url("~@/assets/sidebar/sidebar-icon-refund.svg");
}

.sidebar-icon .icon-withdraw {
  background-image: url("~@/assets/sidebar/sidebar-icon-withdraw-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-withdraw,
.collapse-item.active .sidebar-icon .icon-withdraw {
  background-image: url("~@/assets/sidebar/sidebar-icon-withdraw.svg");
}

.collapse-item:hover .sidebar-icon .icon-withdraw,
.collapse-item:hover .sidebar-icon .icon-withdraw {
  background-image: url("~@/assets/sidebar/sidebar-icon-withdraw.svg");
}

.sidebar-icon .icon-order-fee {
  background-image: url("~@/assets/sidebar/sidebar-icon-order-fee-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-order-fee,
.collapse-item.active .sidebar-icon .icon-order-fee {
  background-image: url("~@/assets/sidebar/sidebar-icon-order-fee.svg");
}

.collapse-item:hover .sidebar-icon .icon-order-fee,
.collapse-item:hover .sidebar-icon .icon-order-fee {
  background-image: url("~@/assets/sidebar/sidebar-icon-order-fee.svg");
}

.sidebar-icon .icon-voucher {
  background-image: url("~@/assets/sidebar/sidebar-icon-voucher-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-voucher,
.collapse-item.active .sidebar-icon .icon-voucher {
  background-image: url("~@/assets/sidebar/sidebar-icon-voucher.svg");
}

.collapse-item:hover .sidebar-icon .icon-voucher,
.collapse-item:hover .sidebar-icon .icon-voucher {
  background-image: url("~@/assets/sidebar/sidebar-icon-voucher.svg");
}

.sidebar-icon .icon-announcement {
  background-image: url("~@/assets/sidebar/sidebar-icon-announcement-disable.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-announcement,
.collapse-item.active .sidebar-icon .icon-announcement {
  background-image: url("~@/assets/sidebar/sidebar-icon-announcement.svg");
}

.collapse-item:hover .sidebar-icon .icon-announcement,
.collapse-item:hover .sidebar-icon .icon-announcement {
  background-image: url("~@/assets/sidebar/sidebar-icon-announcement.svg");
}

.sidebar-icon .icon-manage {
  background-image: url("~@/assets/sidebar/sidebar-icon-general.svg");
  width: -webkit-fill-available;
}

.collapse-item.active .sidebar-icon .icon-manage,
.collapse-item.active .sidebar-icon .icon-manage {
  background-image: url("~@/assets/sidebar/sidebar-icon-general-active.svg");
}

.collapse-item:hover .sidebar-icon .icon-manage,
.collapse-item:hover .sidebar-icon .icon-manage {
  background-image: url("~@/assets/sidebar/sidebar-icon-general-active.svg");
}

.sidebar-admin-button {
  border-radius: 100px !important;
  background-color: #f9f9fb !important;
  border: 0px !important;
  color: #424143 !important;
  box-shadow: 2px 3px 7px rgb(0 0 0 / 16%);
  font-weight: bold !important;
}

.sidebar-admin-button::after {
  color: rgba(255, 175, 003, 1);
}

.sidebar-admin-button:focus {
  box-shadow: 0px 0px 20px rgb(0 0 0 / 20%) !important;
}

.sidebar-admin-button .icon {
  color: #e0e3ec;
}

.sidebar-admin-menu {
  background-color: #f9f9fb !important;
}

.sidebar-admin-item:hover {
  background-color: #ced4da !important;
}

.sidebar-admin-item:focus {
  background-color: #ced4da !important;
  color: #000 !important;
}
</style>
